import React, { useEffect, useState } from "react";

export default function AdminNewsletterDialog({ open, onClose, onSave, initial = null, isSaving = false }) {
  const [form, setForm] = useState({
    title: "",
    description: "",
    date: "",
    type: "",
    downloadLink: "",
    file: null,
    active: false,
  });

  useEffect(() => {
    if (initial) {
      setForm({
        title: initial.title || "",
        description: initial.description || "",
        date: (() => {
          const d = initial.date;
          if (!d) return "";
          if (d instanceof Date) return d.toISOString().slice(0, 10);
          const n = Number(d);
          if (!Number.isNaN(n)) {
            const maybe = n > 1e12 ? new Date(n) : new Date(n * 1000);
            if (!Number.isNaN(maybe.getTime())) return maybe.toISOString().slice(0, 10);
          }
          const parsed = new Date(d);
          if (!Number.isNaN(parsed.getTime())) return parsed.toISOString().slice(0, 10);
          return String(d);
        })(),
        type: initial.type || "",
        downloadLink: initial.downloadLink || "",
        file: null,
        active: !!initial.active,
      });
    } else {
      setForm({ title: "", description: "", date: "", type: "", downloadLink: "", file: null, active: false });
    }
  }, [initial, open]);

  if (!open) return null;

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm((f) => ({ ...f, [name]: type === "checkbox" ? checked : value }));
  };

  const handleFileChange = (e) => {
    const file = e.target.files && e.target.files[0];
    setForm((f) => ({ ...f, file }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (isSaving) return;
    const fd = new FormData();
    fd.append("title", form.title || "");
    fd.append("description", form.description || "");
    // normalize date to ISO at midnight UTC if possible
    let dateVal = "";
    if (form.date instanceof Date) dateVal = form.date.toISOString();
    else if (typeof form.date === "string" && form.date.trim()) {
      const s = form.date.trim();
      const isoCandidate = new Date(s + "T00:00:00Z");
      if (!Number.isNaN(isoCandidate.getTime())) dateVal = isoCandidate.toISOString();
      else dateVal = s;
    }
    fd.append("date", dateVal);
    fd.append("type", form.type || "");
    fd.append("downloadLink", form.downloadLink || "");
    fd.append("active", form.active ? "true" : "false");
    if (form.file) fd.append("file", form.file);
    onSave(fd);
  };

  return (
    <div className="fixed inset-0 bg-black/40 flex items-start justify-center z-50 p-4 sm:items-center">
      <div className="relative bg-white rounded shadow-lg w-full max-w-xl p-6 max-h-[90vh] overflow-y-auto">
        <button
          type="button"
          onClick={onClose}
          className="absolute top-3 right-3 text-gray-500 hover:text-gray-800 text-3xl font-bold leading-none"
          aria-label="Close dialog"
        >
          &times;
        </button>
        <h2 className="text-xl font-semibold mb-4">{initial ? "Edit Newsletter" : "Add Newsletter"}</h2>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="mb-4">
            <label className="block text-sm font-medium mb-2">Title:</label>
            <input
              type="text"
              name="title"
              value={form.title}
              onChange={handleChange}
              className="w-full border border-gray-300 rounded-lg p-2"
            />
          </div>

          <div className="mb-4">
            <label className="block text-sm font-medium mb-2">Date:</label>
            <input
              type="date"
              name="date"
              value={form.date || ""}
              onChange={handleChange}
              className="w-full border border-gray-300 rounded-lg p-2"
            />
          </div>

          <div className="mb-4">
            <label className="block text-sm font-medium mb-2">Type:</label>
            <input
              type="text"
              name="type"
              value={form.type}
              onChange={handleChange}
              className="w-full border border-gray-300 rounded-lg p-2"
            />
          </div>

          <div className="mb-4">
            <label className="block text-sm font-medium mb-2">Active:</label>
            <input
              type="checkbox"
              name="active"
              checked={form.active}
              onChange={handleChange}
              className="mr-2"
            />
          </div>

          <div className="mb-4">
            <label className="block text-sm font-medium mb-2">Download link (URL):</label>
            <input
              type="text"
              name="downloadLink"
              value={form.downloadLink}
              onChange={handleChange}
              className="w-full border border-gray-300 rounded-lg p-2"
            />
          </div>


          <div className="mb-4">
            <label className="block text-sm font-medium mb-2">Description:</label>
            <textarea
              name="description"
              value={form.description}
              onChange={handleChange}
              className="w-full border border-gray-300 rounded-lg p-2"
            />
          </div>

          <div className="flex justify-end gap-3">
            <button type="button" onClick={onClose} className="px-4 py-2 border rounded" disabled={isSaving}>Cancel</button>
            <button type="submit" className={`px-4 py-2 rounded text-white ${isSaving ? "bg-blue-300 cursor-not-allowed" : "bg-blue-600 hover:bg-blue-700"}`} disabled={isSaving}>
              {isSaving ? "Saving..." : "Save"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
